// optisel-frontend/src/pages/issues/IssueAge.tsx
import React from "react";

function daysSinceCreation(creationInstant: string): number {
    const diffMs = Date.now() - new Date(creationInstant).getTime();
    return Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));
}

function formatDaysUnit(days: number): string {
    return days === 1 ? "dzień" : "dni";
}

export function IssueAge(props: { creationInstant: string }) {
    const days = daysSinceCreation(props.creationInstant);
    return <div className={"fw-boldest fs-5"}>Istnieje od: {days} {formatDaysUnit(days)}</div>;
}
